<script lang="ts" setup>
	import FormElementWrapper from '@/views/components/form-elements/partials/form-element-wrapper.vue';
	import {FormElementSelect} from '@/scripts/types/generated';
	import {FormField} from '@/components/ui/form';

	const $props = withDefaults(defineProps<Partial<FormElementSelect>>(), {
		category: 'field',
	});
</script>

<template>
	<FormField
		v-slot="{componentField}"
		:name="$props.name as string"
	>
		<FormElementWrapper v-bind="{...$attrs, ...$props}">
			<Select v-bind="{...$attrs, ...componentField}">
				<FormControl>
					<SelectTrigger>
						<SelectValue :placeholder="$props.placeholder" />
					</SelectTrigger>
				</FormControl>
				<SelectContent>
					<SelectItem
						v-for="option in $props.options"
						:key="option.id"
						:value="option.value"
					>
						{{ option.label }}
					</SelectItem>
				</SelectContent>
			</Select>
		</FormElementWrapper>
	</FormField>
</template>
